import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { InsightsDataFetchSource } from 'owa-meeting-insights-types-and-flights';
import { assertNever } from 'owa-assert';

export function isDataSourceShowingEmails(insightsEntrySource: InsightsDataFetchSource): boolean {
    if (isHostAppFeatureEnabled('showMinimumThreeInsights')) {
        return true;
    }

    switch (insightsEntrySource) {
        case InsightsDataFetchSource.ItemPeek:
        case InsightsDataFetchSource.AgendaView:
            return false;
        case InsightsDataFetchSource.ReadingPane:
        case InsightsDataFetchSource.CalendarCard:
        case InsightsDataFetchSource.PrefetchOnCalendarSelected:
        case InsightsDataFetchSource.Reminder:
        case InsightsDataFetchSource.Deeplink:
        case InsightsDataFetchSource.PrefetchOnAgendaView:
        case InsightsDataFetchSource.TimePanelEventDetails:
            return true;
        default:
            return assertNever(insightsEntrySource);
    }
}

export function isDataSourceMaxPerObjectType(
    insightsEntrySource: InsightsDataFetchSource
): boolean {
    if (isHostAppFeatureEnabled('showMinimumThreeInsights')) {
        return true;
    }

    switch (insightsEntrySource) {
        case InsightsDataFetchSource.ItemPeek:
        case InsightsDataFetchSource.AgendaView:
        case InsightsDataFetchSource.TimePanelEventDetails:
        case InsightsDataFetchSource.Reminder:
            return false;
        case InsightsDataFetchSource.ReadingPane:
        case InsightsDataFetchSource.PrefetchOnCalendarSelected:
        case InsightsDataFetchSource.Deeplink:
        case InsightsDataFetchSource.PrefetchOnAgendaView:
        case InsightsDataFetchSource.CalendarCard:
            return true;
        default:
            return assertNever(insightsEntrySource);
    }
}
